<template>
	<div
		:id="`html-${chronicId}`"
		v-html="moduleContent"
	>
	</div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';

import _has from 'lodash/has';
import url from 'url';
import offsiteLinks from 'webmd-offsite/index.es6';

export default {
	name: 'HtmlModule',
	data() {
		return {
			moduleContent: '',
			imgServer: '',
			domain: 'www.webmd.com',
		};
	},
	mixins: [offsiteLinks],
	props: {
		chronicId: {
			type: String,
			required: true,
		},
	},
	computed: {
		getModuleByChronicId() {
			return this.store.cms.getModules(this.chronicId);
		},

		getModuleContent() {
			const moduleData = this.getModuleByChronicId;
			let parsedContent;
			this.setVariables();
			if (_has(moduleData, 'module_data.contentText')) {
				parsedContent = this.unescape(this.replaceTokens(moduleData.module_data.contentText));
				if (this.store.pagedata.omniture.s_topic === '4121') {
					// add Rel Link Attribute to External Links on Branded Pages
					parsedContent = this.addRelAttribute(parsedContent);
				}
				return parsedContent;
			}

			// eslint-disable-next-line prefer-template
			return '<!-- html-module (' + this.chronicId + '): no module data found -->';
		},
	},

	methods: {
		unescape(content) {
			return content
				.replace(/&apos/g, '\'')
				.replace(/&quot;/g, '"')
				.replace(/&amp;/g, '&')
				.replace(/&lt;/g, '<')
				.replace(/&gt;/g, '>');
		},

		replaceTokens(content) {
			return content
				.replace(/{IMAGE_SERVER_URL}/g, this.imgServer)
				.replace(/{BASE_URL}/g, `https://${this.domain}`)
				.replace(/{ENV}/g, this.getEnv())
				.replace(/{LIFECYCLE}/g, this.getLifecycle())
				.replace(/{VERBOSE-LIFECYCLE}/g, this.getLifecycle(true));
		},

		getEnv() {
			if (this.domain.includes('qa01.')) {
				return 'qa01.';
			}

			if (this.domain.includes('dev01.')) {
				return 'dev01.';
			}

			return '';
		},

		getLifecycle(verbose) {
			if (this.domain.includes('preview.')) {
				if (!verbose) {
					return 'preview.';
				}

				return 'preview';
			}

			if (this.domain.includes('staging.')) {
				if (!verbose) {
					return 'staging.';
				}

				return 'staging';
			}

			if (verbose) {
				return 'live';
			}

			return '';
		},

		setVariables() {
			if (this.store.pagedata.omniture) {
				this.domain = url.parse(`http://${this.store.pagedata.omniture.s_pagename}`).host;
				this.imgServer = this.store.pagedata.omniture.image_server_url;
			}
		},

		addRelAttribute(content) {
			/* eslint-disable no-param-reassign */
			content = content.replace(/\n/g, ' ').replace(/\t/g, '');
			const aRegex = /<a\s*(.*?)>(.*?)<\/a>/g;
			const hrefRegex = /\s*href\s*=\s*"(.*?)"/;  //eslint-disable-line
			const relAttr = ' rel="sponsored"';

			let matchedLinkTags;
			// eslint-disable-next-line no-cond-assign
			while ((matchedLinkTags = aRegex.exec(content)) !== null) {
				const aTag = matchedLinkTags[0];
				const attrs = matchedLinkTags[1];
				const hrefMatch = hrefRegex.exec(attrs);
				if (hrefMatch) {
					const href = hrefMatch[1];
					if (href && !href.includes('webmd.com') && (href.includes('https:')
					|| href.includes('http:')) && !attrs.includes('rel=')) {
						const newATag = aTag.replace('>', `${relAttr}>`);
						content = content.replace(aTag, newATag);
					}
				}
			}
			/* eslint-disable no-param-reassign */
			return content;
		},
	},
	created() {
		this.store = useStore(this.$pinia);
		this.moduleContent = this.getModuleContent;
	},
	mounted() {
		const self = this;
		const elements = this.$el.querySelectorAll('[data-metrics-module]');
		elements.forEach((el) => {
			self.$bindMetrics(el, {});
		});

		self.handleOffsiteLinks();

		// Bind to the window for ext script usage
		window.webmd = window.webmd || {};
		window.webmd.handleOffsiteLinks = self.handleOffsiteLinks;
		window.webmd.handleOffsiteRedirect = self.handleOffsiteRedirect;

	},
};
</script>
